export const treeListOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  searchShow: false,
  searchBtn: false,
  refreshBtn: false,
  columnBtn: false,
  menu: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  viewBtn: false,
  searchBtn: false,
  column: [
    {
      label: '区域',
      prop: 'regionName',
      editDisabled: true,
    },
    {
      label: '市场',
      prop: 'marketName',
      editDisabled: true,
    },
    {
      label: '树木当前阶段',
      prop: 'status',
      editDisabled: true,
    },
    {
      label: '员工总数',
      prop: 'marketTotalNumber',
      editDisabled: true,
    },
    {
      label: '已领取阳光人数',
      prop: 'gotPlantingNumber',
      editDisabled: true,
    },
    {
      label: '实际播撒人数',
      prop: 'presentPlantingNumber',
      editDisabled: true,
    },
    {
      label: '达成百分比',
      prop: 'plantingPercent',
      editDisabled: true,
    },
  ]
}